// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "4e596ef3" + ".css";
};